import React from "react";
import CookieConsentDialog from "./account/CookieConsentDialog";
import { useCookieConsent } from "../context/CookieConsentProvider";

const AutoCookieConsentDialog = () => {
  const { dialogOpen, handleAccept, handleDecline, handleClose } =
    useCookieConsent();


  return (
    <CookieConsentDialog
      open={dialogOpen}
      onClose={handleClose}
      onAccept={handleAccept}
      onDecline={handleDecline}
    />
  );
};

export default AutoCookieConsentDialog;
